export default __webpack_public_path__ + "static/7-2da39fc4a0310461c9b32c1ae6ddf930.png";